module.exports = require("react-redux");


//////////////////
// WEBPACK FOOTER
// external "react-redux"
// module id = 39
// module chunks = 0